export default "__VITE_ASSET__DnbWffKy__"